export const ModuleAuth = 'auth';
export const ModuleNotification = 'notification';
export const ModuleUser = 'user';
export const ModuleLicenseInfo = 'licenseinfo';
//Mới InvoiceBots
export const ModuleOrganization = 'organization';
export const ModuleInvoice = 'invoice';
export const ModuleInvoiceFiles = 'invoicefiles';
export const ModuleInbox = 'inbox';
export const ModuleSupplier = 'supplier';
export const ModuleResource = 'resource';
export const ModuleLayout = 'layout';
export const ModuleColumnExport = 'columnexport';
export const ModuleStick = 'stick';
export const ModuleInvoiceTrial = 'invoicetrial';
export const ModuleAudditingLog = 'auditinglog';
export const ModuleAgreement = 'agreement';
export const ModuleInvoicesCheckingUpdate = 'invoicesCheckingUpdate';
export const ModuleConnectInvoice = 'connectInvoice';
export const ModuleMisaId = 'misaid';
export const ModuleSetting = 'settingsystem';
export const ModuleRole = 'rolepermission';
export const ModuleOutInvoice = 'outinvoice';
export const ModuleVersionFeature = 'versionfeature';
export const ModuleInternal = 'internal';
export const ModuleNotificationUser = 'notificationuser';
export const ModuleOrganizationTransferInvoice = 'organizationtransferinvoice';
export const ModuleSupplierNoDownInv = 'suppliernodowninv';
export const ModuleSupplierOnlyDownInv = 'supplieronlydowninv';
export const ModuleTransferInvByTaxCode = 'transferinvbytaxcode';
export const ModuleConnectTaxaxionEvent = 'connecttaxaxionevent';
export const ModelueSupplierAcceptTax = 'supplieraccepttaxauthority';
export const ModuleEmailReceiveAlert = 'emailreceivealert';
export const ModuleInvoiceCheckHistory = 'invoicecheckhistory';
export const ModuleReport = 'report';
export const ModuleCustomDeclaration = 'customsdeclaration';
export const ModuleConfirmGoodsVatRate = 'confirmgoodsvatrate';
export const ModuleUserSetup = 'usersetup';
export const ModuleAvaReport = 'avareport';
export const ModuleImport = 'import';
export const ModuleAcceptCheckingResult = 'acceptcheckingresult';
export const ModuleConfirmBusiness = 'confirmBusiness';
export const ModuleSubscriber = 'subscriber';
export const ModuleIntructionVideo = 'intructionsvideo';
export const ModuleCriteriaSetup = 'criteriasetup';
export const ModuleAbbreviationSetup = 'abbreviationsetup';
export const ModuleAnalysisReport = 'analysisreport';
export const ModuleNavigation = 'navigation';
export const ModuleSendToDeveloper = 'sendtodeveloper';
export const ModuleNotificationBanner = 'notificationBanner';

/**
 * Danh sách module cần reset lại dữ liệu khi chọn lại mã số thuế
 */
export const ResetModules = [
	ModuleAuth,
	ModuleNotification,
	ModuleUser,
	ModuleLicenseInfo,
	ModuleOrganization,
	ModuleInvoice,
	ModuleInvoiceFiles,
	ModuleInbox,
	ModuleSupplier,
	ModuleResource,
	ModuleInvoicesCheckingUpdate,
	ModuleLayout,
	ModuleStick,
	ModuleColumnExport,
	ModuleAudditingLog,
	ModuleAgreement,
	ModuleConnectInvoice,
	ModuleMisaId,
	ModuleSetting,
	ModuleRole,
	ModuleOutInvoice,
	ModuleVersionFeature,
	ModuleInternal,
	ModuleNotificationUser,
	ModuleConnectTaxaxionEvent,
	ModelueSupplierAcceptTax,
	ModuleEmailReceiveAlert,
	ModuleInvoiceCheckHistory,
	ModuleReport,
	ModuleCustomDeclaration,
	ModuleConfirmGoodsVatRate,
	ModuleUserSetup,
	ModuleAvaReport,
	ModuleImport,
	ModuleAcceptCheckingResult,
	ModuleConfirmBusiness,
	ModuleSubscriber,
	ModuleIntructionVideo,
	ModuleCriteriaSetup,
	ModuleAnalysisReport,
	ModuleNavigation,
	ModuleSendToDeveloper
];
